import { useLocation } from "react-router-dom";
import { useCallback, useState } from "react";
import { Outlet } from "react-router-dom";

import { Header } from "@/components/ui/admin/Header";

export function AdminLayout() {
  const { pathname } = useLocation();
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const toggleMobileNav = useCallback(() => {
    setIsMobileNavOpen((open) => !open);
  }, []);

  const closeMobileNav = useCallback(() => {
    setIsMobileNavOpen(false);
  }, []);

  return (
    <div className="flex min-h-0 flex-1 flex-col antialiased">
      <Header
        pathname={pathname}
        isMobileNavOpen={isMobileNavOpen}
        onMenuToggle={toggleMobileNav}
        onNavClick={closeMobileNav}
      />

      <main className="flex min-h-0 flex-1 flex-col overflow-hidden bg-whart-bg">
        <Outlet />
      </main>
    </div>
  );
}
